import { render, staticRenderFns } from "./ArchitectPassport.vue?vue&type=template&id=f9818718&scoped=true"
import script from "./ArchitectPassport.vue?vue&type=script&lang=js"
export * from "./ArchitectPassport.vue?vue&type=script&lang=js"
import style0 from "./ArchitectPassport.vue?vue&type=style&index=0&id=f9818718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9818718",
  null
  
)

export default component.exports